import { css } from '@emotion/core'

export const errorTooltip = css`
  text-align: right;

  span {
    display: inline-flex;
  }
`
